/**
 * Trajeto percorrido pela equipe desde o empenho (vindo do Ares Frotas), desenhado como linha no mapa.
 *
 * Carga inicial pelo `occurrence_dispatches/{id}/track`; depois, cada posição nova que chega pelo websocket entra na
 * linha (quem usa liga `appendTrailPoint` ao `onFleetPositionsApplied` do FleetPositionsMixin).
 */
const MIN_STEP_METERS = 8
// Ponto ao vivo a até esta distância de um ponto do histórico já foi gravado pelo Frotas.
const SAME_POINT_METERS = 3

function meters(a, b) {
  const dLat = (b.lat - a.lat) * 111320
  const dLng = (b.lng - a.lng) * 111320 * Math.cos(((a.lat + b.lat) / 2) * (Math.PI / 180))

  return Math.sqrt(dLat * dLat + dLng * dLng)
}

export default {
  data() {
    return {
      // código da equipe => [{ lat, lng }]
      trails: {},
      trailMeta: {},
      // código => pontos recebidos ao vivo desde a última carga (o histórico do Frotas chega atrasado em relação a eles)
      trailLive: {},
    }
  },

  methods: {
    /** @returns {Promise<object|null>} o corpo `data` do endpoint, ou null se falhou (a tela segue sem a linha) */
    async loadTrail(dispatchId, code) {
      try {
        const res = await this.$http.get(`${this.$store.state.api}occurrence_dispatches/${dispatchId}/track`)
        const data = res.data.data || {}
        const points = (data.points || []).map(p => ({ lat: Number(p.lat), lng: Number(p.lng) }))

        this.$set(this.trails, code, this.mergeLiveTail(code, points))
        this.$set(this.trailMeta, code, { from: data.from, to: data.to, truncated: !!data.truncated, live: !!data.live })

        return data
      } catch (e) {
        return null
      }
    },

    /**
     * Histórico do Frotas + pontos ao vivo que ele ainda não tem. A recarga periódica não pode apagar o que o
     * websocket já entregou: guarda só a cauda posterior ao último ponto ao vivo que o histórico já contém.
     */
    mergeLiveTail(code, history) {
      const live = this.trailLive[code] || []
      const lastKnown = live.map(p => history.some(h => meters(h, p) <= SAME_POINT_METERS)).lastIndexOf(true)
      const tail = live.slice(lastKnown + 1)
      this.$set(this.trailLive, code, tail)

      return history.concat(tail)
    },

    appendTrailPoint(code, lat, lng) {
      const trail = this.trails[code]
      if (!trail) return

      const point = { lat: Number(lat), lng: Number(lng) }
      const last = trail[trail.length - 1]

      if (last && meters(last, point) < MIN_STEP_METERS) return

      trail.push(point)
      if (!this.trailLive[code]) this.$set(this.trailLive, code, [])
      this.trailLive[code].push(point)
    },

    trailPath(code) {
      return this.trails[code] || []
    },
  },
}
